// extracted by mini-css-extract-plugin
module.exports = {"switcher":"Switcher_switcher__1x481","switchItem":"Switcher_switchItem__3x3K8","isSelected":"Switcher_isSelected__3GE-n"};